import 'bootstrap';
import './scss/style.scss';

import MfShared from "./components/mf-shared";
new MfShared();

import MfHeaderHeight from "./components/mf-header-height";
MfHeaderHeight.init({ selector: '.header', cssVarName: '--header-h' });

import MfNavLock from './components/mf-nav-lock';
MfNavLock.init({ collapseSelector: '#navbarContent' });

import "./components/mf-text-toggle";
